import styled from "styled-components";

export const ShowMoreLinkRoot = styled("a")`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
